<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row">
        <div class="col-md-3" @click="showTableByStatus(255)">
          <stats-card
            id="totalCandidates"
            title="Total Candidates"
            type="gradient-red"
            :sub-title="totalCandidates"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="col-md-3" @click="showTableByStatus(1)">
          <stats-card
            id="totalActiveCandidates"
            title="Active Candidates"
            type="gradient-red"
            :sub-title="totalActiveCandidates"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="col-md-3" @click="showTableByStatus(0)">
          <stats-card
            id="totalInactiveCandidates"
            title="Inactive Candidates"
            type="gradient-red"
            :sub-title="totalInactiveCandidates"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <employees-table :status="candidateStatusTable"></employees-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmployeesTable from "./Tables/EmployeesTable";
import EventBus from "./../event-bus";

export default {
  name: "tables",
  components: {
    EmployeesTable
  },
  data() {
    return {
      totalCandidates: "0",
      totalActiveCandidates: "0",
      totalInactiveCandidates: "0",
      candidateStatusTable: "255"
    };
  },
  mounted() {
    this.getTotalCandidate();
    this.getTotalActiveCandidate();
    this.getTotalInactiveCandidate();
    this.showTableByStatus(this.candidateStatusTable);

    $("#userManagement").removeClass("collapse");

    EventBus.$on("updateEmployeeCount", () => {
      this.getTotalActiveCandidate();
      this.getTotalInactiveCandidate();
    });
  },
  methods: {
    showTableByStatus(status) {
      if (status == "255") {
        this.candidateStatusTable = "255";
        $("#totalCandidates").addClass("bg-yellow");
        $("#totalActiveCandidates").removeClass("bg-yellow");
        $("#totalInactiveCandidates").removeClass("bg-yellow");
      } else if (status == "1") {
        this.candidateStatusTable = "1";
        $("#totalCandidates").removeClass("bg-yellow");
        $("#totalActiveCandidates").addClass("bg-yellow");
        $("#totalInactiveCandidates").removeClass("bg-yellow");
      } else if (status == "0") {
        this.candidateStatusTable = "0";
        $("#totalCandidates").removeClass("bg-yellow");
        $("#totalActiveCandidates").removeClass("bg-yellow");
        $("#totalInactiveCandidates").addClass("bg-yellow");
      }
    },

    getTotalCandidate() {
      this.$store
        .dispatch("fetchTotalEmployee", { status: 255 })
        .then(response => {
          this.totalCandidates = response.data.toString();
        });
    },

    getTotalActiveCandidate() {
      this.$store
        .dispatch("fetchTotalEmployee", { status: 1 })
        .then(response => {
          this.totalActiveCandidates = response.data.toString();
        });
    },

    getTotalInactiveCandidate() {
      this.$store
        .dispatch("fetchTotalEmployee", { status: 0 })
        .then(response => {
          this.totalInactiveCandidates = response.data.toString();
        });
    }
  }
};
</script>
<style></style>
